import { REPORT_TYPES } from '@repo/constants'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/reports/ecc')({
  staticData: {
    title: REPORT_TYPES.ECC,
    crumb: REPORT_TYPES.ECC,
    permissions: ['reports_view_ecc'],
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
